import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { op, take } from '@lib/rxjs';
import { muckpileQuery } from '@models';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { TaggedMuckpileMapService } from './tagged-muckpile-map.service';
import { PRIMARY_COLOR } from 'src/colors';

@Component({
    selector: 'tagged-muckpile',
    templateUrl: './tagged-muckpile.component.html',
    styleUrls: ['./tagged-muckpile.component.scss']
})
export class ShowTaggedMuckpileComponent {
    public muckpileData$ = this.fragQuery.taggedMuckpileData$;
    public particleSizeUnit$ = this.fragQuery.particleSizeUnit$;
    public areaUnit$ = this.fragQuery.AreaAbbr$;
    public muckpile: muckpileQuery.list.MuckpileInfo;
    public readonly muckpiles$ = this.fragQuery.muckpiles$;
    public readonly yAxisTitle$ = this.fragQuery.QuantityTitle$;
    private mapInitialized = false;
    @ViewChild('map', { static: false }) mapElement: ElementRef;

    public taggedMuckpile$ = this.muckpiles$.pipe(
        op.filter(muckpiles => Array.isArray(muckpiles) && muckpiles.length > 0),
        op.map(muckpiles => muckpiles.find(muckpile => muckpile.id === this.data.muckpileId) || null),
        op.filter(muckpile => !!muckpile),
        op.shareReplay(1)
    );

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            muckpileId: number
        },
        private fragQuery: FragQueryService,
        private readonly host: MatDialogRef<ShowTaggedMuckpileComponent, boolean>,
        private taggedMuckpileMapService: TaggedMuckpileMapService
    ) { }

    ngOnInit() {
        this.taggedMuckpile$.subscribe((data: muckpileQuery.list.MuckpileInfo) => {
            this.muckpile = data;

            if (this.mapInitialized) {
                this.taggedMuckpileMapService.addPolygon({
                    coordinates: this.muckpile.geometry.coordinates,
                    color: PRIMARY_COLOR,
                    title: this.muckpile.name
                });
                this.taggedMuckpileMapService.reCenterMap(this.muckpile.geometry.coordinates[0][0], 16)
            }
        });
    }

    ngAfterViewInit() {
        if (!this.mapInitialized) {
            this.taggedMuckpileMapService.initializeMap([0, 0], this.mapElement);
            this.mapInitialized = true;

            this.taggedMuckpile$.pipe(take(1)).subscribe((data: muckpileQuery.list.MuckpileInfo) => {
                this.muckpile = data;
                this.taggedMuckpileMapService.addPolygon({
                    coordinates: this.muckpile.geometry.coordinates,
                    color: PRIMARY_COLOR,
                    title: this.muckpile.name
                });
                this.taggedMuckpileMapService.reCenterMap(this.muckpile.geometry.coordinates[0][0], 16);
            });
        }
    }

    ngOnDestroy() {
        this.taggedMuckpileMapService.cleanup();
        this.mapInitialized = false;
    }

    public cancel() {
        this.host.close(false);
    }

    public isEmptyObject = (obj:muckpileQuery.details.Fragment): boolean => {
        return obj === null || obj === undefined ||
            (Array.isArray(obj.psd) && obj.psd.length === 0) &&
            (Array.isArray(obj.dxx) && obj.dxx.length === 0);
    };
}
